"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("../../shared/service/http.service");
var find_http_error_1 = require("../../shared/error/find-http-error");
var DispatchService = /** @class */ (function () {
    function DispatchService(_httpService) {
        this._httpService = _httpService;
        this.SHIPPING_COMPANIES = DispatchService.DISPATCH_END_POINT + "/findShippingCompanyTypes";
    }
    DispatchService.prototype.findShippingCompanies = function () {
        return this._httpService.get(this.SHIPPING_COMPANIES, Array, find_http_error_1.FindHttpError);
    };
    DispatchService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    DispatchService.DISPATCH_END_POINT = '/dispatch';
    return DispatchService;
}());
exports.DispatchService = DispatchService;
//# sourceMappingURL=dispatch.service.js.map


// WEBPACK FOOTER //
// dispatch.service.js